// extracted by mini-css-extract-plugin
export var box = "_5v-0";
export var check = "_5v-1";
export var checkboxButton = "_5v-6";
export var checkboxGroup = "_5v-5";
export var disabled = "_5v-7";
export var ghost = "_5v-9";
export var input = "_5v-2";
export var label = "_5v-4";
export var normal = "_5v-8";
export var uncheck = "_5v-3";